// extracted by mini-css-extract-plugin
module.exports = {"title":"NotFound_title__xtpvY"};